import { Plan } from '@lucidtech/las-sdk-browser';

export const enterprisePlan: Partial<Plan> = {
  name: 'Enterprise',
  planId: 'custom',
  currency: 'USD',
  latest: 0,
};

export const planFeatures = {
  Individual: [
    '500 pages per month',
    '1 user',
    '2 agents',
    'Human-in-the-loop UI',
    'Workflow builder',
    'Automatic AI training',
    'All integrations',
    'Basic support',
  ],
  Team: [
    '5000 pages per month',
    '5 users',
    '5 agents',
    'Advanced validation rules',
    'Custom data retention',
    'Priority support',
  ],
  Enterprise: [
    'Volume discounts',
    'SSO & role-based access controls',
    'Customer success manager',
    'Custom billing options',
    'Premium support & SLAs',
  ],
};

const removeDeprecatedPlans = (plans?: Plan[]): Plan[] => {
  if (!plans) return [];

  const validPlans = ['individual', 'team'];

  return plans?.filter((plan) => {
    if (plan.organizationId === 'cradl:organization:cradl') {
      return validPlans.some((p) => plan.planId?.includes(p));
    } else {
      return true;
    }
  });
};

export const createAndGroupPlans = (plans?: Plan[]): Record<string, Plan[]> => {
  const res: Record<string, Plan[]> = {
    monthly: [],
    annually: [],
  };

  if (!plans) return res;

  for (const plan of removeDeprecatedPlans(plans)) {
    if (plan.license?.billingCycle === 1) {
      res.monthly = [...res.monthly, plan];
    } else if (plan.license?.billingCycle === 12) {
      res.annually = [...res.annually, plan];
    }
  }

  res.monthly.push({ ...enterprisePlan, billingCycle: 1 } as Plan);
  res.annually.push({ ...enterprisePlan, billingCycle: 12 } as Plan);

  return res;
};

export const toCanonicalPlanId = (planId?: string | null) => {
  if (!planId) return null;
  if (planId.includes('cradl:organization')) return planId;
  return `cradl:organization:cradl/${planId}`;
};
